export const FAUCET_APT = "0xa";
